export default {"src":"/_next/static/media/card-insights.e2ab7234.svg","height":61,"width":61,"blurWidth":0,"blurHeight":0};